<div class="flex gap-space-x3" [formGroup]="form">
  <div class="custom-mat-form-wrapper time-field">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-select panelClass="custom-mat-select-panel" [formControl]="hourControl" hideSingleSelectionIndicator>
        <mat-option *ngFor="let hour of state.hourOptions; trackBy: trackByValue" [value]="hour">
          {{ hour | number : '2.00' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="custom-mat-form-wrapper time-field">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-select panelClass="custom-mat-select-panel" [formControl]="minuteControl" hideSingleSelectionIndicator>
        <mat-option *ngFor="let minute of state.minuteOptions; trackBy: trackByValue" [value]="minute">
          {{ minute | number : '2.00' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
